module.exports = __webpack_public_path__ + "static/media/ashiYokoage.b50dd8aa.png";